import { useNavigate } from 'react-router-dom'
// import Navigation from './Navigation/Navigation'
import logo from '../../../../assets/image/logo/logo.svg'
import { AccountLink } from '@think-internet/zeus-frontend-package/auth/types'
import { useSelector } from 'react-redux'
import props from '../../../../redux/props'
import useDidScroll from './useDidScroll'

type Props = { hideNavigation?: boolean; headerTransparent?: boolean }

const Header: React.FC<Props> = ({ hideNavigation = false, headerTransparent = false }) => {
  const navigate = useNavigate()
  const accountLink: AccountLink = useSelector((s) => s[props.ACCOUNT_LINK])
  const isLoggedIn = () => !!accountLink
  const t = useSelector((s) => s[props.TRANSLATION])
  const didScroll = useDidScroll()

  const goHome = () => {
    let path = '/'
    if (isLoggedIn()) {
      path = '/dashboard'
    }
    navigate(path)
  }

  return (
    <div
      className={`z-20 h-20 transition-all top-0 left-0 fixed w-full ${
        !headerTransparent && 'shadow-md'
      } flex flex-row items-center justify-between px-3 ${didScroll && 'bg-red'}`}
    >
      <div className={`absolute top-0 left-0 w-full h-full -z-10 ${!headerTransparent && 'bg-red'}`}></div>
      <div onClick={goHome} className={`cursor-pointer ${!accountLink && 'mx-auto'}`}>
        <img src={logo} alt={t.projectName} className={'h-9'} />
      </div>
      {/* {!hideNavigation && <Navigation />} */}
    </div>
  )
}

export default Header
